<template>
  <div :class="['chi-narrative-wrapper', state]" :style="{
    height: height + 'px',
    width: width + 'px'
  }">
    <div class="chi-narrative-window" :style="{
      height: height - 28 + 'px',
      width: width + 'px'
    }">
      <div class="chi-narrative-content">
        <div class="chi-narrative-section edit" v-html="edit_template"></div>
        <div class="chi-narrative-section view" v-html="view_template"></div>
      </div>
    </div>
    <kendo-toolbar class="chi-narrative-toolbar">
      <kendo-toolbar-spacer />
      <kendo-toolbar-item>
        <kendo-button-group>
          <kendo-button data-narrative-button="true" data-send="edit" :selected="edit_selected" :toggleable="true">Edit</kendo-button>
          <kendo-button data-narrative-button="true" data-send="view" :selected="view_selected" :toggleable="true">View</kendo-button>
        </kendo-button-group>
      </kendo-toolbar-item>
    </kendo-toolbar>
  </div>
</template>

<style lang="scss">
.chi-narrative-window {
  overflow-x: hidden;
  position: relative;
}
.chi-narrative-content {
  min-height: 100%;
  left: 100%;
  position: absolute;
  width: 100%;
}
.chi-narrative-section {
  background: white;
  min-height: 100%;
  padding: 0.57143rem;
  position: absolute;
  top: 0;
  width: 100%;
  &.edit {
    display: block;
    right: 100%;
  }
  &.view {
    display: none;
    right: 0;
  }
}
.chi-narrative-wrapper.edit .chi-narrative-section.edit,
.chi-narrative-wrapper.transition .chi-narrative-section.edit,
.chi-narrative-wrapper.view .chi-narrative-section.view,
.chi-narrative-wrapper.transition .chi-narrative-section.view {
  display: block;
}
.chi-narrative-wrapper.edit .chi-narrative-section.view,
.chi-narrative-wrapper.view .chi-narrative-section.edit {
  display: none;
}
.chi-narrative-wrapper .chi-narrative-toolbar .k-button-group .k-button {
  margin-left: 0;
  &[selected] {
    background-color: #4c8de0;
    background-image: none;
    color: rgba(255, 255, 255, 0.9);
  }
}
.chi-narrative-wrapper input,
.chi-narrative-wrapper .k-dropdown-wrap {
  background: transparent !important;
  border-color: transparent transparent #676d75 transparent !important;
  box-shadow: none !important;
  height: auto !important;
  padding: 3px !important;
}
.chi-narrative-wrapper .k-dropdown-wrap .k-select {
  border-color: transparent !important;
  background-color: transparent !important;
  width: auto !important;
  height: auto !important;
}
</style>

<script>
import $ from 'jquery';
import {Button, ButtonGroup} from '@progress/kendo-buttons-vue-wrapper';
import {Toolbar, ToolbarItem, ToolbarSpacer} from '@progress/kendo-vue-buttons';


//const REGEXPS = {
//  CLONE_ID: /\$\d+$/
//};


export default {
  name: 'Narrative',
  components: {
    'kendo-button': Button,
    'kendo-button-group': ButtonGroup,
    'kendo-toolbar': Toolbar,
    'kendo-toolbar-item': ToolbarItem,
    'kendo-toolbar-spacer': ToolbarSpacer
  },
  data: function () {return {
    edit_selected: true,
    results: [],
    state: 'edit',
    view_selected: false,
  }},
  watch: {
    button_clicked: function (button) {
      var state = this.state;
      if (state !== 'transition') {
        this.state = 'transition';
        var edit = (button === 'edit');
        var self = this;
        if (button === state) {
          this.state = state;
        } else {
          this.fx = this.fx ||
            kendo.fx($('.chi-narrative-content', this.$el)).slideIn('right');
          (edit ? this.fx.play() : this.fx.reverse()).then(function () {
            self.state = button;
            self.view_selected = !(self.edit_selected = edit);
          });
        }
      }
    },
  },
  props: {
    button_clicked: 'edit',
    edit_template: {default: '<em>--no data--</em>'},
    height: {default: '20rem'},
    view_template: {default: '<em>--no data--</em>'},
    width: {default: '40rem'}
  }
};
</script>
